import axios from 'axios';
import { adminmi, tanlanganTuman } from './foydalanuvchi';
import { joriyTil } from './til';

// Sessiya tugaganini login sahifasiga yetkazish uchun belgi.
export const SESSION_TUGADI = 'sessiya_tugadi';

// Token eskirganda (yoki JWT_SECRET almashganda) server 401 qaytaradi.
// Busiz panel foydalanuvchini chiqarmasdan ochiq turaverar, ro'yxatlar bo'sh
// ko'rinar va har bir amal "Token yaroqsiz" xatosi bilan tugar edi.
export const authInterceptorniOrnat = () => {
  // Admin tanlagan tuman har bir probatsiya so'roviga qo'shiladi. Shu
  // bitta joyda qilingani uchun sahifalardagi o'nlab so'rovning birortasini
  // o'zgartirish kerak bo'lmadi.
  axios.interceptors.request.use((config) => {
    // Server xabarlari (xato, "saqlandi") panel tilida qaytsin.
    config.headers = config.headers || {};
    config.headers['x-til'] = joriyTil();

    const tuman = tanlanganTuman();
    if (tuman && adminmi() && String(config.url || '').includes('/probatsiya/')) {
      config.headers = config.headers || {};
      config.headers['x-tuman-id'] = tuman;
    }
    return config;
  });

  axios.interceptors.response.use(
    res => res,
    err => {
      const login = window.location.pathname === '/login';

      // Login sahifasidagi 401 — bu "parol noto'g'ri", sessiya emas.
      // U yerda o'z xabari ko'rsatiladi, aralashmaymiz.
      if (err.response?.status === 401 && !login) {
        localStorage.removeItem('token');
        sessionStorage.setItem(SESSION_TUGADI, '1');
        window.location.replace('/login');
      }

      return Promise.reject(err);
    }
  );
};
